import { fetchPostReferralCode } from '#/api/apiExchange';
import { staticDispatch } from '#/reduxState/store';

import { setReferralCode, setReferralCodeApplied } from './userReferral';

export function applyAndDispatchReferralCode(
  walletAddress: string,
  referralCode: string
) {
  if (!referralCode || !walletAddress) {
    return;
  }
  fetchPostReferralCode(walletAddress, referralCode)
    .then(result => {
      console.log('Result of Referral Submit Code: ', result);
      // remove from state once applied so we do not try to apply on future unlocks
      staticDispatch(setReferralCodeApplied(true));
    })
    .catch(error => {
      console.warn(
        `Failed to apply saved referral code: ${referralCode}: `,
        error
      );
      switch (error.idexErrorCode) {
        case 'INVALID_CIRCULAR_REFERRAL_ERROR':
        case 'INVALID_SELF_REFERRAL_ERROR':
        case 'WALLET_ALREADY_REFERRED': {
          // we can remove the code from state in this case
          staticDispatch(setReferralCode(undefined));
          break;
        }
        default:
          break;
      }
    });
}
